var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMap = function SvgMap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15.99 4.288-4.5-1.5h-.053a.526.526 0 0 0-.104 0h-.323L6.75 4.25 2.49 2.788a.75.75 0 0 0-.675.105.75.75 0 0 0-.315.607V14a.75.75 0 0 0 .51.713l4.5 1.5a.75.75 0 0 0 .465 0l4.275-1.425 4.26 1.462c.08.011.16.011.24 0a.705.705 0 0 0 .435-.142.75.75 0 0 0 .315-.608V5a.75.75 0 0 0-.51-.712ZM6 14.458l-3-.998V4.543l3 .997v8.918Zm4.5-.998-3 .998V5.54l3-.997v8.917Zm4.5.998-3-.998V4.543l3 .997v8.918Z"
  })));
};
export default SvgMap;